module.exports = [{"value":"ซิโนฟาร์ม","text":"ซิโนฟาร์ม"},{"value":"ซิโนแวค","text":"ซิโนแวค"},{"value":"ไฟเซอร์","text":"ไฟเซอร์"},{"value":"โมเดอร์นา","text":"โมเดอร์นา"},{"value":"แอสตราเซเนกา","text":"แอสตราเซเนกา"},{"value":"จอห์นสันแอนด์จอหน์สัน","text":"จอห์นสันแอนด์จอหน์สัน"},{"value":"mRNA","text":"mRNA"},{"value":"ไข้หวัดใหญ่","text":"ไข้หวัดใหญ่"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/vaccine/vaccineName.json
// module id = Fy+1
// module chunks = 2